export enum ShipmentDetailsPath {
    invoiceNumber = "invoiceNumber",
    activeTab = "activeTab"
  }
  
  export interface PathParams {
    [ShipmentDetailsPath.invoiceNumber]: string;
    [ShipmentDetailsPath.activeTab]: string;
  }
  